import React from 'react';
import { useCurrency } from './CurrencyContext';
type PriceProps = {
  amount: number;
};
export function Price({
  amount
}: PriceProps) {
  const {
    formatPrice
  } = useCurrency();
  return <span data-price={amount} data-id="element-100" data-mp="2dcs5g75r60qq">{formatPrice(amount)}</span>;
}